<template>
  <li>
    <div @click="$router.push('/participants/' + item.id)" :style="'background-image:url(' + encodeURI(image) + ')'" class="headshot-img"></div>
    <h4 v-html="name"></h4>
  </li>
</template>

<script>
export default {
  props: ['item', 'image', 'name'],
};
</script>

<style scoped lang="less">
@import '../css/variables';

li {
  width: 90px;
  margin-right: 3vw;
  text-align: center;
  cursor: pointer;
  &:active {
    .headshot-img {
      filter: brightness(0.6);
    }
  }
  .headshot-img {
    width: 90px;
    min-width: 90px;
    height: 90px;
    min-height: 90px;
    margin: 0 auto 10px auto;
    background-size: cover;
    background-position: center;
    background-color: #262626;
    border-radius: 70px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.46);
    &.square {
      border-radius: 5px;
    }
  }
  h4 {
    font-size: 16px;
    text-align: center;
    word-break: break-word;
    @media (max-width: @mobile) {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Headshot.vue